import { normalizeUrl } from "../../lib/index.mjs";
import { Link } from "../Link.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Provider(_ref) {
  var {
    url,
    providerUrl,
    providerName,
    showUrl
  } = _ref;
  var favicon = "https://avatars-cdn.prezly.com/favicon?url=".concat(encodeURIComponent(url), "?ideal_height=32");
  var href = showUrl ? url : homepage(providerUrl || url);
  var provider = showUrl ? url : providerName || hostname(providerUrl || url);
  return /*#__PURE__*/_jsxs(Link, {
    className: 'prezly-slate-bookmark-card-component__provider',
    href: href,
    newTab: true,
    children: [/*#__PURE__*/_jsx("img", {
      className: 'prezly-slate-bookmark-card-component__providerIcon',
      src: favicon,
      alt: "".concat(provider, " favicon"),
      "aria-hidden": "true"
    }), /*#__PURE__*/_jsx("span", {
      className: 'prezly-slate-bookmark-card-component__providerName',
      children: provider
    })]
  });
}
function hostname(url) {
  var {
    host
  } = new URL(normalizeUrl(url));
  return host;
}
function homepage(url) {
  var {
    origin
  } = new URL(normalizeUrl(url));
  return origin;
}